export function needsClientProfile(user) {
  if (!user) return false;
  if (typeof user.profile_required === 'boolean') return user.profile_required;
  return !user.is_child_account && !user.parent_account_info && !user.is_profile_completed;
}

export function clientPermissions(user) {
  if (Array.isArray(user?.my_permissions)) return user.my_permissions;
  if (user?.is_child_account || user?.parent_account_info) return [];
  return user?.my_permissions === '__all__' ? '__all__' : [];
}